export default __webpack_public_path__ + "static/media/Interior.3dd18cd8.jpg";